module.exports = __webpack_public_path__ + "media/images/icon-marker-69d5d51b12bd2e0acdd9c6464f3500ab.png";